import axios from 'axios';

const getList = params => axios.get('/modos-pagamentos', {
  params,
});
const get = id => axios.get(`/modos-pagamentos/${id}`, {});

const save = (modoPagamento) => {
  if (modoPagamento.id) {
    return axios.put(`/modos-pagamentos/${modoPagamento.id}`, modoPagamento);
  }
  return axios.post('/modos-pagamentos', modoPagamento);
};

const remover = id => axios.delete(`/modos-pagamentos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
